import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { EBuildingClassType } from '../../../../api-models/common/json_query';

const ID = 'buildingClassType' as const;

const CLASS_MAP_VALUE_TO_LABEL: Record<EBuildingClassType, string> = {
  [EBuildingClassType.A]: 'Класс A',
  [EBuildingClassType.APlus]: 'Класс A+',
  [EBuildingClassType.B]: 'Класс B',
  [EBuildingClassType.BPlus]: 'Класс B+',
  [EBuildingClassType.BMinus]: 'Класс B-',
  [EBuildingClassType.C]: 'Класс C',
  [EBuildingClassType.CPlus]: 'Класс C+',
  [EBuildingClassType.D]: 'Класс D',
};

export const buildingClassTypeTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const types = getTermsValue('building_class_type')(jsonQuery);

    if (types === null) {
      return null;
    }

    return types.map(t => ({
      label: CLASS_MAP_VALUE_TO_LABEL[t],
      value: createTagValue(ID, t.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const types = getTermsValue('building_class_type')(jsonQuery);

    if (types === null) {
      return jsonQuery;
    }

    const next = types.filter(t => String(t) !== removingTagValue);

    return next.length > 0
      ? setTerms('building_class_type')(jsonQuery)(next)
      : resetTerms(['building_class_type'])(jsonQuery);
  },
};
